// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5753) return "static/chunks/5753-ecdc0192e58a0ff0.js";
	if (chunkId === 3112) return "static/chunks/3112-e5850fb31efa0de3.js";
	if (chunkId === 1995) return "static/chunks/1995-0483f40e464f4f55.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"2974":"27269722","7157":"57d80fc9","9712":"cbfddaed"}[chunkId] || chunkId) + "." + {"561":"1b1aa2f46292c763","1864":"83663fb9a3419195","2273":"898e8f4338f6d2f0","2562":"0e676802ce63c33c","2974":"c16bf547627f2ace","3115":"38d1b3818c2ac522","7157":"28a7310bcea380dd","7757":"ed58c89768c0747c","9381":"85f981dd99a05e79","9712":"7724f22eddac77df"}[chunkId] + ".js";
};